function MobileMenu(el, triggerEl) {
    this.el = el;
    this.triggerEl = triggerEl;
    this.focusedElBeforeOpen = null;
    this.focusableEls = [this.triggerEl, ...this.el.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')];
    this.firstFocusableEl = this.focusableEls[0];
    this.lastFocusableEl = this.focusableEls[this.focusableEls.length - 1];

    this.triggerEl.addEventListener('click', e => {
        e.preventDefault();
        this.toggleVisibility();
    });

    window.addEventListener('resize', _ => { if (window.innerWidth >= 1450) this.hide() });
    window.addEventListener('keyup', e => { if (e.key.toLowerCase() == 'escape') this.hide() });

    window.addEventListener('keydown', e => {
        const tabIsPressed = e.key === 'Tab';

        if (!tabIsPressed) return;

        if (e.shiftKey) {
            if (document.activeElement === this.firstFocusableEl) {
                this.lastFocusableEl.focus();
                e.preventDefault();
            }
        }
        else {
            if (document.activeElement === this.lastFocusableEl) {
                this.firstFocusableEl.focus();
                e.preventDefault();
            }
        }
    });
}

MobileMenu.prototype.toggleVisibility = function() {
    if (this.el.classList.contains('open')) this.hide();
    else this.show();
};

MobileMenu.prototype.show = function() {
    this.triggerEl.classList.add('open');

    // Prevent overflow on the HTML and body
    document.documentElement.classList.add('no-overflow');
    document.body.classList.add('no-overflow');

    // Accessibility stuff
    this.focusedElBeforeOpen = document.activeElement;
    this.el.focus();
    document.body.ariaHidden = true;
    this.el.ariaHidden = false;
    this.triggerEl.ariaExpanded = true;
    this.triggerEl.ariaLabel = 'Verberg het hoofdmenu';

    // Show animation
    const slideInEls = [this.el.querySelector('.jsMobileMenuAccessBtns'), ...this.el.querySelectorAll('.mobile-main-menu li')];
    const footerBottomEl = this.el.querySelector('.jsMobileMenuBottom');

    gsap.timeline()
        .set(this.el, { xPercent: 100, display: 'block' })
        .set([...slideInEls, footerBottomEl], { y: 20, opacity: 0 })

        .to(this.el, 0.5, { xPercent: 0, ease: Power2.easeInOut })
        .to(slideInEls, 0.5, { y: 0, opacity: 1, stagger: 0.08, ease: Power2.easeInOut }, '-=0.2')
        .to(footerBottomEl, 0.5, { y: 0, opacity: 1 }, '-=0.7')

        .add(_ => this.el.classList.add('open'))
        .set([this.el, ...slideInEls, footerBottomEl], { clearProps: 'all' })
    ;
};

MobileMenu.prototype.hide = function() {
    if (this.el.classList.contains('open')) {
        this.triggerEl.classList.remove('open');

        // Reset overflow on the HTML and body
        document.documentElement.classList.remove('no-overflow');
        document.body.classList.remove('no-overflow');

        // Accessibility stuff
        this.focusedElBeforeOpen = null;
        document.body.ariaHidden = false;
        this.el.ariaHidden = true;
        this.triggerEl.ariaExpanded = false;
        this.triggerEl.ariaLabel = 'Toon het hoofdmenu';

        if (window.innerWidth >= 1000) document.body.querySelector('.jsTopLogo').focus();
        else if (this.focusedElBeforeOpen) this.focusedElBeforeOpen.focus();

        // Show animation
        const slideInEls = [this.el.querySelector('.jsMobileMenuAccessBtns'), ...this.el.querySelectorAll('.mobile-main-menu li')];
        const footerBottomEl = this.el.querySelector('.jsMobileMenuBottom');

        gsap.timeline()
            .to(slideInEls, 0.5, { y: 20, opacity: 0, stagger: 0.08, ease: Power2.easeInOut })
            .to(footerBottomEl, 0.5, { y: 20, opacity: 0, ease: Power2.easeInOut }, '-=0.5')
            .to(this.el, 0.5, { xPercent: 100, ease: Power2.easeInOut }, '-=0.2')

            .add(_ => this.el.classList.remove('open'))
            .set([this.el, ...slideInEls, footerBottomEl], { clearProps: 'all' })
        ;
    }
};

(function() {
    const mobileMenuTriggerEl = document.querySelector('.jsMobileMenuTrigger');

    if (mobileMenuTriggerEl) {
        const mobileMenuEl = document.querySelector('.jsMobileMenu');
        new MobileMenu(mobileMenuEl, mobileMenuTriggerEl);
    }
})();